import { GetListParams } from 'react-admin';
import {
  CustomDataProvider,
  registerModuleDataProvider,
} from '../../../providers/CustomDataProvider';
import {
  WithdrawalListFilter,
  listWithdrawals,
} from '../../../services/xbitRelayWithdrawalsService';
import { DEFAULT_WITHDRAWALS_PROVIDER } from './constants';

const resourceName = 'xbit-relay/withdrawals';

const pickFilter = (filter: any): WithdrawalListFilter => {
  if (!filter) return {};
  const out: WithdrawalListFilter = {};
  if (filter.status) out.status = filter.status;
  if (filter.userId) out.userId = filter.userId;
  if (filter.id) out.recordId = filter.id;
  if (filter.toAddress) out.toAddress = filter.toAddress;
  if (filter.txHash) out.txHash = filter.txHash;
  return out;
};

export const xbitRelayWithdrawalsDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 20 } = params.pagination || {};
    const filter = params.filter || {};
    const provider = filter.provider || DEFAULT_WITHDRAWALS_PROVIDER;

    const response = await listWithdrawals({
      ...pickFilter(filter),
      provider,
      page,
      pageSize: perPage,
    });

    const { items = [], total } = response.data || ({} as any);
    return {
      data: items.map((item) => ({ ...item, id: item.id })),
      total: Number(total) || 0,
    };
  },
};

registerModuleDataProvider(resourceName, xbitRelayWithdrawalsDataProvider);
